import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext/hooks";
import Accordion from "modules/common/components/Accordion";
import Grid from "modules/common/components/Grid";
import { MinusIcon, PlusIcon } from "styles/icons";
import accordionItems from "./accordionItems";
import { FAQ_ANCHOR } from "../../../consts";

const { Box, Flex, Heading } = Chakra;

const FAQ = () => {
  const translations = useTranslations();

  return (
    <Box id={FAQ_ANCHOR} py={{ base: 10, md: 20 }}>
      <Grid mb={0}>
        <Box gridColumn={{ base: "span 1", md: "span 12" }}>
          <Flex
            align={{ base: "flex-start", lg: "center" }}
            justify="space-between"
            flexDir={{ base: "column", lg: "row" }}
            pb={4}
          >
            <Heading variant="h2" as="h2" pb={4}>
              {translations("faq_questions")}
            </Heading>
          </Flex>
          <Accordion
            items={accordionItems}
            icons={{ close: <MinusIcon color="primary.500" w={3} />, open: <PlusIcon color="primary.500" w={3} /> }}
          />
        </Box>
      </Grid>
    </Box>
  );
};

export default FAQ;
